module.exports = __webpack_public_path__ + "media/customizations/serenbe/logo-44f035c044a17a58806fdc2a06505e50.png";